export const endpoints = Object.freeze({
    LOGIN: '/login/',
    POSTS: '/posts/',
    MY_POSTS: '/posts/mine',
    SEARCH: '/posts/search',
    STICKY: '/posts/sticky',
    VALIDATE: '/posts/v/',
    GARAGE: '/posts/garage',
    REPORT: '/report/',
    MODERATE: '/admin/moderate/',
    APPROVE: '/admin/approve/',
    JUDGE: '/admin/judge/',
    UPLOAD: '/upload/'
});